<template>
	<div class="cart__product cartitem">
		<div class="cartitem__img">
			<img :src="item.currentColor.image.path" alt="">
		</div>

		<div class="cartitem__info">
			<div class="cartitem__title">
				Модель: {{ item.title }}
				<small>Серия: {{ item.seria.title }}</small>
			</div>
			<div class="cartitem__color">
				<span :style="'background:'+ item.currentColor.color.code"></span>Цвет: {{ item.currentColor.title }}
			</div>
		</div>
		<div class="cartitem__price"><span class="cartitem__desc">Цена <i v-if="prepay == 1">по предоплате</i>: </span> {{ showPrice }} ₽</div>

		<div class="cartitem__count">
			<span class="cartitem__desc">Количество: </span>
			<div class="props__count">
				<button uk-icon="minus" @click="minus"></button>
				<strong>{{ count }}</strong>
				<button uk-icon="plus" @click="plus"></button>
			</div>
		</div>

		<div class="cartitem__total"><span class="cartitem__desc">Всего: </span> {{ showPrice * count | cifer }} ₽</div>

		<div class="cartitem__close" @click="removeItem()" title="Удалить продукт">
			<span uk-icon="close"></span>
		</div>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  import { finance } from "../mixins/finance";

  export default {
    name: "cart-item",
    mixins: [finance],
    data() {
      return {
        count: '',
	      prepay: 1
      }
    },
    props: {
      item: ''
    },
    methods: {
      plus() {
        this.count++;
        this.updateCart();
      },
      minus() {
        if (this.count > 1) {
          this.count--;
          this.updateCart();
        }
      },
      updateCart() {
        let item = this.item;
        item.count = this.count;
        let app = this;
        $.request('onUpdateCount', {
          data: { item: item },
          success: function (data) {
            console.log(data);
            app.$emit('updateCount', data.item);
            bus.$emit('cart-reload', data.cart);
          },
          error: function (err) {
            console.log(err);
          }
        })
      },
      removeItem() {
        let app = this;
        $.request('onRemoveItem', {
          data: { item: this.item },
          success: function (data) {
            //console.log(data);
            app.$emit('removeFromCart', data.id);
            bus.$emit('cart-reload', data.cart);
          },
          error: function (err) {
            console.log(err);
          }
        })
      },
	    changePrepay(data){
        this.prepay = data;
	    }
    },
    mounted() {
      bus.$on('change-prepay', this.changePrepay);
      this.count = this.item.count;
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/cart-item.vue